export default __webpack_public_path__ + "static/media/regisImg2.60dc23b7.jpg";